// ABOUTME: Calendar empty state icon for showing no activities
// ABOUTME: Supports className, size, and color customization via stroke

interface IconProps {
  className?: string
  size?: number
  color?: string
}

export const CalendarEmptyIcon = ({ className = "", size = 24, color = "currentColor" }: IconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
      stroke={color}
    />
  </svg>
)
